// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__sbi8k","load4":"Loading_load4__yk8fY"};